import React from 'react';

const CityIcon = (props) => {
  return (
    <img
      alt="Miasto"
      src="/static/images/icons/tourist_attractions/city.svg"
      {...props}
    />
  );
};

export default CityIcon;
